<template>
  <spinner-container :loading="localLoading">
    <back-btn />
    <v-container fluid>
      <v-row justify="center">
        <v-col lg="12">
          <training-list :volunteer_id="volunteer_id" />
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col lg="10">
          <vlu-form :volunteer="volunteer" @emitData="updateVolunteer" />
        </v-col>
      </v-row>
    </v-container>
  </spinner-container>
</template>

<script>
import VluForm from "@/components/volunteer/VluForm";
import TrainingList from "@/components/volunteer/training/TrainingList";
import { mapState } from "vuex";
import SpinnerContainer from "@/components/container/SpinnerContainer";
import BackBtn from "@/components/navigation/BackBtn.vue";

export default {
  components: {
    VluForm,
    TrainingList,
    SpinnerContainer,
    BackBtn,
  },
  data: () => ({
    cumps: [
      {
        text: "Home",
        disabled: false,
        href: "/",
      },
      {
        text: "Volunteer",
        disabled: false,
        href: "/volunteer",
      },
      {
        text: "Volunteer Form",
        disabled: true,
      },
    ],
  }),
  computed: {
    ...mapState("Volunteer", ["volunteer"]),
    ...mapState("Loading", ["localLoading"]),
    volunteer_id() {
      return String(this.$route.params.id);
    },
  },
  methods: {
    updateVolunteer(payload) {
      this.$store
        .dispatch("Volunteer/updateVolunteer", payload)
        .then((isPass) => {
          if (isPass) this.$router.push("/volunteer");
        });
    },
  },
  created() {
    this.$store.dispatch("Loading/changeLocalLoading");
    this.$store
      .dispatch("Volunteer/getVolunteer", this.$route.params.id)
      .then(() => {
        this.$store.dispatch("Loading/changeLocalLoading");
      });
  },
};
</script>
